import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { CaseDetails } from 'app/shared-html-components/details/details.component';
import { TransferCaseCommonFunction } from '../transfer-functions';
import { PartnerTransferCase, TransferCaseData, CaseOverviewCase, TransferCaseStatusData, TransferCaseInputCase } from '../transfer-models';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { CompanyInformation, Responsible, Fitter } from 'app/shared-html-components/details/models';
import { PartnerCompany } from 'app/shared/api/partner.api'; 
import { CompanyUsers } from '../../settings/users/users.component';
import { Router } from '@angular/router';
import { ClickPreventer } from 'app/shared/utilities/developHelpers';
import { SubscriptionObject } from 'app/shared/models/standard.models';

@Component({
  selector: 'transfer-ekomplet-case',
  templateUrl: './transfer-ekomplett-case.component.html',
  styleUrls: ['./transfer-ekomplett-case.component.css']
})
export class TransferEkomplettCaseComponent implements OnInit, OnChanges, OnDestroy {
  @Input() case: TransferCaseInputCase;
  @Input() openModal = false;
  @Input() type: string;
  @Output() update = new EventEmitter();
  @Output() reload = new EventEmitter();

  caseType: 'case' | 'partner' | 'partnerCase' | 'partnerOffer' | 'email';
  integrationId = '7e82cc3e-163e-4cb2-ba25-939fc339f021';
  integrationType; // if true then can transfer to Ekomplet (has Udbakke module, checked onInit)
  subscriptions = new SubscriptionObject();
  f = new TransferCaseCommonFunction(this.http);

  partnerCase: PartnerTransferCase;
  departments;
  dimensionCarrier;
  orderGroups;
  profitGroups;
  priceGroups;
  purposes;
  teamLeaders;
  updating = false;

  customerStep = 'final';
  customerAction;
  standardSettings;
  reject = false;
  data = new TransferCaseData();
  nico = new ClickPreventer();

  constructor(private http: HttpClient, private sharedData: SharedDataService, private router: Router) { }

  ngOnInit(): void {
    let guards = JSON.parse(localStorage.getItem('guards') as string);
    this.integrationType = !!guards.find((x:{ name: string }) => x.name == 'Udbakke Light') ? false : !!guards.find(x => x.name == 'Udbakke') ? true : null;
    this.subscriptions['companyInfo'] = this.sharedData.companyInformation().subscribe((data) => this.f.companyInfo = data);
    this.subscriptions['responsibles'] = this.sharedData.responsibles().subscribe((data) => this.f.responsibles = data);
    this.subscriptions['fitters'] = this.sharedData.fitter().subscribe((data) => this.f.fitters = data);
    this.subscriptions['companyUsers'] = this.sharedData.companyUsers().subscribe((data) => this.f.companyUsers = data?.filter(x => !!x.externalId));
    this.subscriptions['ekSettings'] = this.sharedData.eKompletSettings().subscribe((data) => { this.standardSettings = data; console.log(data) });

    this.getTypes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.case && !!changes.case.currentValue || !!changes.openModal && !!changes.openModal.currentValue) {
      this.reset();
      this.checkCaseType(changes.case.currentValue);
      document.getElementById('transferCaseModalOpener')!.click();
    }
  }

  ngOnDestroy(): void {
    for (let x of Object.keys(this.subscriptions)) this.subscriptions[x].unsubscribe();
  }

  checkCaseType(c) {
    if (!!c.transferTypeId) { this.caseType = 'email' }
    else if (!!c.caseId) { this.caseType = 'case' }
    else {
      if (c.transferId) this.f.getPartnerCase(c.transferId).subscribe((data: PartnerTransferCase) => {
        /*
          PartnerCase and PartnerOffer both lack invoice data in the TransferCaseInputCase, so it will be added when loading the partner case.
        */
        console.log('Partner case', data)
        this.case.invoice = { ...data.invoice, id: null };
        this.partnerCase = data;
        this.caseType = !!this.partnerCase.isOfferRequest ? 'partnerOffer' : 'partnerCase';
      });
    }
  }

  getTypes() {
    this.f.eKompletDepartment().subscribe(data => { this.departments = data; });
    this.f.eKompletDimensionCarrier().subscribe(data => { this.dimensionCarrier = data; });
    this.f.eKompletOrderGroup().subscribe(data => { this.orderGroups = data; });
    this.f.eKompletProfitGroup().subscribe(data => { this.profitGroups = data; });
    this.f.eKompletPriceGroup().subscribe(data => { this.priceGroups = data; });
    this.f.eKompletPurposes().subscribe((data: any[]) => { this.purposes = data.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1); })
    this.f.eKompletTeamLeader().subscribe((data) => this.teamLeaders = data);
  }

  documentAddressChange(event) {
    console.log(event)
    if (!!event.action) {
      switch (this.caseType) {
        case 'case': {
          break
        }
        case 'partnerCase': {
          /*
          convert customer address to partner case data.
          */
          this.case = this.f.addressToPartnerCaseAddress(event, this.case);
          console.log(this.case)
            ; break
        }
      }
    }
    else if (!!event.currentStep) this.customerStep = event.currentStep;
  }

  goToCase() {
    this.router.navigateByUrl("/Details/" + this.case.caseId);
  }

  reset() {
    this.data = {
      ...new TransferCaseData(),
      integrationId: this.integrationId,
      caseId: this.case.caseId,
      eDimensionCarrierId: this.standardSettings.eDimensionCarrierId,
      eDimensionDepartmentId: this.standardSettings.eDimensionDepartmentId,
      eOrderGroupId: this.standardSettings.eOrderGroupId,
      ePriceGroupId: this.standardSettings.ePriceGroupId
    }
    this.partnerCase = null;
    this.openModal = false;
    this.reject = false;
    this.customerStep = 'final';
    this.customerAction = null;
    // createdCaseId ? 

  }

  addMessageToCase(c: any) {
    // if a caseId is provided, send as message on caseId, then remove case from transfers
    // to test send mail to [ companyId ]@mail.jublo.dk
    this.f.messageToCase(c.caseId, this.case.description, this.case.title).subscribe(
      (data) => {
        /*
        Message has been transfered to the case.
        The modal will close when output case has been rejected.
        Component has to refresh the outbox.
        */
        this.f.rejectCase(this.case.transferId).subscribe(
          () => {
            document.getElementById('transferCaseCloseModalBtn')!.click();
            this.update.emit('mailSentToCase');
          }
        )
      },
      err => console.log('Error occurred while transfering message to case')
    )
  }

  async accept(send: boolean) {
    /*
    All data need to be saved before starting.
    */
    switch (this.caseType) {
      case 'case': {
        /*
        Data should be validated in order to press this button.
        Case data is first updated.
        Then it is transferred to ERP and outbox is updated.
        */
        let c = this.case;
        let d = await this.validateERP();
        this.f.editCase(c.caseId, c.title, c.description, c.requisitionNumber, c.reference, c.internalNote).subscribe(
          () => {
            this.f.transferCase(d).subscribe(
              data => this.update.emit('caseAccepted')
            )
          }
        )

        break
      }
      case 'partnerCase': {
        let data = this.f.inputToOutputCase(this.case); // works as validation for creation of a jublo case. Not used yet.
        let d = await this.validateERP();
        this.f.acceptCaseTransfer(this.case.transferId, data).subscribe(
          (caseId: string) => {
            d.caseId = caseId;
            /*
            Case has been created and caseId has been returned.
            */
            if (send) {
              this.f.transferCase(d).subscribe(() => this.update.emit('partnerCaseTransferred'))
            }
            else this.update.emit('partnerCaseAccepted')

          })
        break
      }
      case 'partnerOffer': {
        let data = this.f.inputToOutputCase(this.case); // works as validation for creation of a jublo case. Not used yet.
        let d = await this.validateERP();
        this.f.acceptCaseTransfer(this.case.transferId, data).subscribe(
          (caseId: string) => {
            d.caseId = caseId;
            /*
            Case has been created and caseId has been returned. Could be used to link user to the offer.
            No transfer to the ERP.
            */
            this.update.emit('partnerOfferAccepted')
          }
        )
        break
      }
      case 'email': {
        let data = this.f.inputToOutputCase(this.case); // works as validation for creation of a jublo case. Not used yet.
        let d = await this.validateERP();
        this.f.acceptCaseTransfer(this.case.transferId, data).subscribe(
          (caseId: string) => {
            d.caseId = caseId;
            /*
            Case has been created and caseId has been returned.
            */
            if (send) {
              this.f.transferCase(d).subscribe(() => this.update.emit('emailCaseTransferred'))
            }
            else this.update.emit('emailCaseAccepted');
          })
        break
      }
    }
  }

  rejectCase() {
    this.f.rejectCase(this.case.transferId).subscribe(
      () => {
        document.getElementById('transferCaseCloseModalBtn')!.click();
        this.update.emit('caseRejected');
      }
    )
  }

  cancelCase() {
    this.f.cancelCase(this.case.caseId).subscribe(
      () => {
        document.getElementById('transferCaseCloseModalBtn')!.click();
        this.update.emit('caseCanceled');
      }
    )
  }

  editCase() {
    if (this.caseType == 'case') {
      let c = this.case;
      this.f.editCase(c.caseId, c.title, c.description, c.requisitionNumber, c.reference, c.internalNote).subscribe(() => { })
    }
  }

  async validateERP(): Promise<TransferCaseData> {
    let c = this.case;
    return {
      caseId: c.caseId,
      integrationId: this.integrationId,
      caseTypeId: null,
      customerGroupId: null,
      economySystemGroupId: null,
      parentCaseId: null,
      minubaCaseType: null,
      responsibleId: null,
      foremanId: null,
      eOrderGroupId: this.data.eOrderGroupId,
      eDimensionCarrierId: this.data.eDimensionCarrierId,
      eDimensionDepartmentId: this.data.eDimensionDepartmentId,
      ePriceGroupId: this.data.ePriceGroupId,
      eProfitGroupId: this.data.eProfitGroupId,
      eDimensionPurposeId: this.data.eDimensionPurposeId,
      eProjectType: this.data.eProjectType,
      osDepartmentId: null,
      osStatus: null
    }
  }
}

class EkomplettTransferSubscriptions {
  responsibles: Subscription;
  copmanyInfo: Subscription;
  fitters: Subscription;
  companyUsers: Subscription;
}

class CaseTransferDataHolder {
  integrationId: string;
  companyInfo: CompanyInformation;
  responsibles: Array<Responsible>;
  fitters: Array<Fitter>;
  companyUsers: Array<CompanyUsers>;
  partners: Array<PartnerCompany>;
  showPartners: Array<PartnerCompany>;
  caseTypes: Array<any>;
  customerTypes: Array<any>;
  debitorTypes: Array<any>;
  step: string = 'final';
  documentAddressMessage: string;
  lightCustomer: boolean;
}
